import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarFeminino from "../assets/images/divas.png";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Feminino() {
    useTrackPageView();
    useTimeOnPage();

    const handleWhatsappClick = async () => {
        // Corrigido de 'masculino_cta_main' para 'feminino_cta_main' no analytics
        await trackEvent("whatsapp_click", {
            buttonLocation: "feminino_cta_main",
        });

        // AJUSTADO: Altere para o link de convite real do grupo feminino
        window.open("https://sendwich.pro/grupos/promosclubedasdivas", "_blank");
    };

    return (
        <LandingCategory
            avatar={avatarFeminino}
            titleTop="CHEGA DE PAGAR"
            titleBottom="CARO EM MODA!"
            highlightWord="EM MODA!"
            members="250.000"
            description="Entre no grupo VIP e receba ofertas selecionadas todos os dias! ✨"
            // AJUSTADO: Mesmo link real do grupo aqui embaixo
            whatsappLink="https://sendwich.pro/grupos/promosclubedasdivas"
            telegramLink="https://t.me/seu-link"
            theme={themes.feminino}
            onWhatsappClick={handleWhatsappClick}
        />
    );
}